import {IStore} from "modules/types";
import {createSelector} from "reselect";

export const getErrorState = ({error}: IStore) => error;
export const getErrorMessage = createSelector(getErrorState, ({text}) => text);
export const getErrorCode = createSelector(getErrorState, ({code}) => code);
